<template>
  <div class="tripDetail">
    <div class="wrapper-box" v-if="isEmpty">
      <div class="ranking-tab-wrap">
        <tabsScorll :navList="rankingTab" @changeAllData="myPending" :isShow="currentIndex"></tabsScorll>
        <!-- <tab :tabList="rankingTab" :name="'rankingTab'" :tabFontSize="'14px'" @onSwitch="myPending"></tab> -->
      </div>
      <!-- 基本信息 -->
      <div class="basicinfo-box" v-if="currentIndex == 0">
        <div class="info-box">
          <div class="title">{{tripDetail.routeName}}</div>
          <div class="numbers">行程单号：{{tripDetail.teamNo}}</div>
          <rline></rline>
          <div class="date-box" v-if="tripDetail.teamStartDate">
            <div class="start-box">
              <p class="txt-title">出团时间</p>
              <p class="txt-date">{{(tripDetail.teamStartDate.substring(0,10)).replace(/-/g, "/")}}</p>
              <div class="hourtime">
                <img src="../../assets/travelAgency/ic_time.png" alt class="hour-icon" />
                <div class="times">{{tripDetail.teamStartDate.substring(11,16)}}</div>
              </div>
            </div>
            <div class="allday">共{{tripDetail.teamDayCount}}天</div>
            <div class="endtime">
              <p class="txt-title">散团时间</p>
              <p class="txt-date">{{(tripDetail.teamEndDate.substring(0,10)).replace(/-/g, "/")}}</p>
              <div class="hourtime">
                <img src="../../assets/travelAgency/ic_time.png" alt class="hour-icon" />
                <div class="times">{{tripDetail.teamEndDate.substring(11,16)}}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="msg-box">
          <listItem
            :label="'旅行社名称'"
            :textAlign="'right'"
            :labelWidth="100"
            :ctnColor="'#333333'"
            :showRight="false"
          >{{tripDetail.executeTravelName || '暂无信息'}}</listItem>
          <rline></rline>

          <listItem
            :label="'自编团号'"
            :textAlign="'right'"
            :labelWidth="100"
            :ctnColor="'#333333'"
            :showRight="false"
          >{{tripDetail.selfTeamNo || '暂无信息'}}</listItem>
          <rline></rline>

          <listItem
            :label="'计调人员'"
            :textAlign="'right'"
            :labelWidth="114"
            :ctnColor="'#333333'"
            :showRight="false"
          >{{tripDetail.plannerPerson || '暂无信息'}}</listItem>
          <rline></rline>

          <listItem
            :label="'计调号码'"
            :textAlign="'right'"
            :labelWidth="114"
            :ctnColor="'#333333'"
            :showRight="false"
          >{{ tripDetail.plannerPhone || '暂无信息'}}</listItem>
          <rline></rline>

          <!-- <listItem
            :label="'旅游路线'"
            :textAlign="'right'"
            :labelWidth="114"
            :ctnColor="'#333333'"
            :showRight="false"
          >{{tripDetail.routeName || '暂无信息'}}</listItem>
          <rline></rline> -->

          <listItem
            :label="'团队类型'"
            :showRight="false"
            :textAlign="'right'"
            :labelWidth="114"
            :ctnColor="'#333333'"
          >{{tripDetail.teamTypeStr || '暂无信息'}}</listItem>
          <rline></rline>

          <!-- <listItem
            :label="'客源地'"
            :textAlign="'right'"
            :labelWidth="100"
            :ctnColor="'#333333'"
            :showRight="false"
          >{{tripDetail.teamStartcityName || '暂无信息'}}</listItem>
          <rline></rline> -->
          <listItem
            :label="'团队人数'"
            :textAlign="'right'"
            :labelWidth="114"
            :ctnColor="'#333333'"
            :showRight="false"
          >{{tripDetail.realCount}}</listItem>
          <rline></rline>
          <listItem v-if = "tripDetail.teamType == '11'"
            :label="'委托项目'"
            :textAlign="'right'"
            :labelWidth="114"
            :ctnColor="'#333333'"
            :showRight="false"
          >{{tripDetail.includeItemsCn}}</listItem>
          <rline></rline>
          <!-- <listItem
            :label="'特殊项目'"
            :textAlign="'right'"
            :labelWidth="114"
            :ctnColor="'#333333'"
            :showRight="false"
          >{{tripDetail.specialProject || '暂无信息'}}</listItem> -->
        </div>
        <div class="msg-box">
          <listItem
            :label="'出发地'"
            :textAlign="'right'"
            :labelWidth="114"
            :ctnColor="'#333333'"
            :showRight="false"
          >{{tripDetail.teamStartPlaceName || '暂无信息'}}</listItem>
          <rline></rline>
          <listItem
            :label="'目的地'"
            :textAlign="'right'"
            :labelWidth="114"
            :ctnColor="'#333333'"
            :showRight="false"
          >{{tripDetail.teamEndPlaceName || '暂无信息'}}</listItem>
          <!-- <rline></rline> -->

          <!-- <listItem
            :label="'备注'"
            :textAlign="'right'"
            :labelWidth="114"
            :ctnColor="'#333333'"
            :showRight="false"
          >{{tripDetail.remark || '暂无信息'}}</listItem>
          <rline></rline> -->
          <!-- <listItem
            :label="'抵达时交通'"
            :textAlign="'right'"
            :labelWidth="114"
            :ctnColor="'#333333'"
            :showRight="false"
          >{{tripDetail.teamLongtraffic || '暂无信息'}}</listItem>
          <rline></rline>
          <listItem
            :label="'离开时交通'"
            :showRight="false"
            :textAlign="'right'"
            :labelWidth="114"
            :ctnColor="'#333333'"
          >{{tripDetail.teamoutLongtraffic || '暂无信息'}}</listItem> -->
        </div>

        <!-- 展示不展示保险类字段 -->
        <div v-if="false">
          <div class="msg-box">
            <listItem
              :label="'旅行社责任险投保人数'"
              :textAlign="'right'"
              :labelWidth="168"
              :ctnColor="'#333333'"
              :showRight="false"
            >{{tripDetail.liabilityPerson || '暂无信息'}}</listItem>
            <rline></rline>
            <listItem
              :label="'旅行社责任险单价（元）'"
              :textAlign="'right'"
              :labelWidth="168"
              :ctnColor="'#333333'"
              :showRight="false"
            >{{tripDetail.liabilityPrice ?  `¥${tripDetail.liabilityPrice}/人` : '暂无信息'}}</listItem>
            <rline></rline>
            <listItem
              :label="'旅行社责任险保费（元）'"
              :showRight="false"
              :textAlign="'right'"
              :labelWidth="168"
              :ctnColor="'#333333'"
            >{{tripDetail.liabilityCost ?  `¥${tripDetail.liabilityCost}/人` : '暂无信息'}}</listItem>
          </div>
          <div class="msg-box">
            <listItem
              :label="'游客意外伤害险方案'"
              :textAlign="'right'"
              :labelWidth="168"
              :ctnColor="'#333333'"
              :showRight="false"
            >{{tripDetail.accidentPlan || '暂无信息'}}</listItem>
            <rline></rline>
            <listItem
              :label="'游客意外伤害险投保人数'"
              :textAlign="'right'"
              :labelWidth="168"
              :ctnColor="'#333333'"
              :showRight="false"
            >{{tripDetail.accidentPerson || '暂无信息'}}</listItem>
            <rline></rline>
            <listItem
              :label="'游客意外伤害险单价（元）'"
              :textAlign="'right'"
              :labelWidth="198"
              :ctnColor="'#333333'"
              :showRight="false"
            >{{tripDetail.accidentPrice ?  `¥${tripDetail.accidentPrice}/人` : '暂无信息'}}</listItem>
            <rline></rline>
          </div>
          <listItem
            :label="'保险报案电话'"
            :showRight="false"
            :textAlign="'right'"
            :labelWidth="168"
            :ctnColor="'#36B374'"
          >4008096927</listItem>
        </div>
        <div class="notice-box" v-if="tripDetail.remark">
          <div class="title">备注</div>
          <div class="content-box">{{tripDetail.remark}}</div>
        </div>
        <div class="phoneglobal">
          全国旅游投诉电话：
          <span>12301</span>
        </div>
        <div class="phoneyunnan">
          云南省旅游投诉电话：
          <span>96301</span>
        </div>
      </div>
      <div class="tour-box" v-if="currentIndex == 3">
        <div class="form-box" v-for="(lists,index) in guideList" :key="index">
          <div class="info-box">
            <div class="usernames">{{lists.guideName}}</div>
            <img src="../../assets/travelAgency/ic_bm_cy1.png" alt class="headimg" />
          </div>
          <rline></rline>
          <listItem
            :label="'导游证号'"
            :textAlign="'right'"
            :labelWidth="114"
            :ctnColor="'#333333'"
            :showRight="false"
          >{{lists.guideCertificate || '暂无信息'}}</listItem>
          <rline></rline>
          <listItem
            :label="'导游类型'"
            :textAlign="'right'"
            :labelWidth="114"
            :ctnColor="'#333333'"
            :showRight="false"
          >{{lists.type || '暂无信息'}}</listItem>
          <rline></rline>
          <listItem
            :label="'导游电话'"
            :textAlign="'right'"
            :labelWidth="114"
            :ctnColor="'#333333'"
            :showRight="false"
          >{{ lists.guidePhone|| '暂无信息'}}</listItem>
          <rline></rline>
          <listItem
            :label="'签约旅行社'"
            :textAlign="'right'"
            :labelWidth="100"
            :ctnColor="'#333333'"
            :showRight="false"
          >{{lists.signCompanyName || '暂无信息'}}</listItem>
          <rline></rline>

          <listItem
            :label="'旅行社联系电话'"
            :textAlign="'right'"
            :labelWidth="110"
            :ctnColor="'#333333'"
            :showRight="false"
          >{{ lists.travelPhone || '暂无信息' }}</listItem>
          <rline></rline>
          <listItem
            :label="'出团时间'"
            :textAlign="'right'"
            :labelWidth="100"
            :ctnColor="'#333333'"
            :showRight="false"
          >{{lists.startDate || '暂无信息'}}</listItem>
          <rline></rline>
          <listItem
            :label="'散团时间'"
            :textAlign="'right'"
            :labelWidth="100"
            :ctnColor="'#333333'"
            :showRight="false"
          >{{lists.endDate || '暂无信息'}}</listItem>

        </div>
        <div class="empty-page" v-if="guideList.length === 0">
          <img src="../../assets/travelAgency/ic_wuxingxi.png" alt="" class="ic-img" />
          <p class="texts">暂无数据</p>
        </div>
      </div>
      <div class="car-box" v-if="currentIndex == 4">
        <div class="form-box" v-for="(items,index) in carList" :key="index">
          <!-- 1-飞机  2-火车  3-客车  4-轮船 -->
          <listItem
            :label="'交通类型'"
            :textAlign="'right'"
            :labelWidth="114"
            :ctnColor="'#333333'"
            :showRight="false"
          >{{items.trafficTypeStr || '暂无信息'}}</listItem>
          <rline></rline>
          <div v-if="items.trafficType == '01'">
            <listItem
              :label="'航班号'"
              :textAlign="'right'"
              :labelWidth="114"
              :ctnColor="'#333333'"
              :showRight="false"
            >{{items.trafficNumber || '暂无信息'}}</listItem>
            <rline></rline>
            <listItem
              :label="'出发时间'"
              :textAlign="'right'"
              :labelWidth="114"
              :ctnColor="'#333333'"
              :showRight="false"
            >{{items.startDate || '暂无信息'}}</listItem>
            <rline></rline>
            <listItem
              :label="'出发机场'"
              :textAlign="'right'"
              :labelWidth="114"
              :ctnColor="'#333333'"
              :showRight="false"
            >{{items.teamStartPlace || '暂无信息'}}</listItem>
            <rline></rline>
            <listItem
              :label="'是否中转'"
              :textAlign="'right'"
              :labelWidth="114"
              :ctnColor="'#333333'"
              :showRight="false"
            >{{items.isTransfer == '0' ? '否' : '是' || '暂无信息'}}</listItem>
            <rline></rline>

            <div v-if="items.isTransfer == '1'">
              <listItem
                :label="'中转机场'"
                :textAlign="'right'"
                :labelWidth="114"
                :ctnColor="'#333333'"
                :showRight="false"
              >{{ items.transferPlace || '暂无信息' }}</listItem>
              <rline></rline>
              <listItem
                :label="'中转时长'"
                :textAlign="'right'"
                :labelWidth="114"
                :ctnColor="'#333333'"
                :showRight="false"
              >{{ timeChange(items.transferStartDate, items.transferEndDate) }}</listItem>
              <rline></rline>
            </div>

            <listItem
              :label="'到达机场'"
              :textAlign="'right'"
              :ctnColor="'#333333'"
             :labelWidth="114"
               :showRight="false"
            >{{items.teamEndPlace || '暂无信息'}}</listItem>
            <rline></rline>
            <listItem
              :label="'到达时间'"
              :textAlign="'right'"
              :labelWidth="114"
              :ctnColor="'#333333'"
              :showRight="false"
            >{{items.endDate || '暂无信息'}}</listItem>
          </div>

          <div v-if="items.trafficType == '02'">
            <listItem
              :label="'车次'"
              :textAlign="'right'"
              :labelWidth="114"
              :ctnColor="'#333333'"
              :showRight="false"
            >{{items.trafficNumber || '暂无信息'}}</listItem>
            <rline></rline>
            <listItem
              :label="'出发时间'"
              :textAlign="'right'"
              :labelWidth="114"
              :ctnColor="'#333333'"
              :showRight="false"
            >{{items.startDate || '暂无信息'}}</listItem>
            <rline></rline>
            <listItem
              :label="'出发站'"
              :textAlign="'right'"
              :labelWidth="114"
              :ctnColor="'#333333'"
              :showRight="false"
            >{{items.teamStartPlace || '暂无信息'}}</listItem>
            <rline></rline>
            <listItem
              :label="'是否中转'"
              :textAlign="'right'"
              :labelWidth="114"
              :ctnColor="'#333333'"
              :showRight="false"
            >{{items.isTransfer == '0' ? '否' : '是' || '暂无信息'}}</listItem>
            <rline></rline>

            <div v-if="items.isTransfer == '1'">
              <listItem
                :label="'中转站111'"
                :textAlign="'right'"
                :labelWidth="114"
                :ctnColor="'#333333'"
                :showRight="false"
              >{{items.transferPlace || '暂无信息'}}</listItem>
              <rline></rline>
              <listItem
                :label="'中转时长'"
                :textAlign="'right'"
                :labelWidth="114"
                :ctnColor="'#333333'"
                :showRight="false"
              >{{ timeChange(items.transferStartDate, items.transferEndDate) }}</listItem>
              <rline></rline>
            </div>

            <listItem
              :label="'到达时间'"
              :textAlign="'right'"
              :labelWidth="114"
              :ctnColor="'#333333'"
              :showRight="false"
            >{{items.endDate || '暂无信息'}}</listItem>
          </div>

          <div v-if="items.trafficType == '03'">
            <listItem
              :label="'车牌号'"
              :textAlign="'right'"
              :labelWidth="114"
              :ctnColor="'#333333'"
              :showRight="false"
            >{{items.carPlate || '暂无信息'}}</listItem>
            <rline></rline>
            <listItem
              :label="'车牌颜色'"
              :textAlign="'right'"
              :labelWidth="114"
              :ctnColor="'#333333'"
              :showRight="false"
            >{{items.plateColor || '暂无信息'}}</listItem>
            <rline></rline>
            <listItem
              :label="'车企公司'"
              :textAlign="'right'"
              :labelWidth="114"
              :ctnColor="'#333333'"
              :showRight="false"
            >{{items.motorCorporationName || '暂无信息'}}</listItem>
            <rline></rline>
            <listItem
              :label="'驾驶员姓名'"
              :textAlign="'right'"
              :labelWidth="114"
              :ctnColor="'#333333'"
              :showRight="false"
            >{{items.driverName || '暂无信息'}}</listItem>
            <rline></rline>
            <listItem
              :label="'驾驶员电话'"
              :textAlign="'right'"
              :labelWidth="114"
              :ctnColor="'#333333'"
              :showRight="false"
            >{{ items.driverPhone || '暂无信息' }}</listItem>
            <rline></rline>
            <listItem
              :label="'出团时间'"
              :textAlign="'right'"
              :labelWidth="114"
              :ctnColor="'#333333'"
              :showRight="false"
            >{{items.startDate || '暂无信息'}}</listItem>
            <rline></rline>
            <listItem
              :label="'散团时间'"
              :textAlign="'right'"
              :labelWidth="114"
              :ctnColor="'#333333'"
              :showRight="false"
            >{{items.endDate || '暂无信息'}}</listItem>
          </div>

          <div v-if="items.trafficType == '04'">
            <listItem
              :label="'船号'"
              :textAlign="'right'"
              :labelWidth="114"
              :ctnColor="'#333333'"
              :showRight="false"
            >{{items.trafficNumber || '暂无信息'}}</listItem>
            <rline></rline>
            <listItem
              :label="'出发时间'"
              :textAlign="'right'"
              :labelWidth="114"
              :ctnColor="'#333333'"
              :showRight="false"
            >{{items.startDate || '暂无信息'}}</listItem>
            <rline></rline>
            <listItem
              :label="'出发港口'"
              :textAlign="'right'"
              :labelWidth="114"
              :ctnColor="'#333333'"
              :showRight="false"
            >{{items.teamStartPlace || '暂无信息'}}</listItem>
            <rline></rline>
            <listItem
              :label="'是否中转'"
              :textAlign="'right'"
              :labelWidth="114"
              :ctnColor="'#333333'"
              :showRight="false"
            >{{items.isTransfer == '0' ? '否' : '是' || '暂无信息'}}</listItem>
            <rline></rline>

            <div v-if="items.isTransfer == '1'">
              <listItem
                :label="'中转港口'"
                :textAlign="'right'"
                :labelWidth="114"
                :ctnColor="'#333333'"
                :showRight="false"
              >{{items.transferPlace || '暂无信息'}}</listItem>
              <rline></rline>
              <listItem
                :label="'中转时长'"
                :textAlign="'right'"
                :labelWidth="114"
                :ctnColor="'#333333'"
                :showRight="false"
              >{{ timeChange(items.transferStartDate, items.transferEndDate) }}</listItem>
              <rline></rline>
            </div>

            <listItem
              :label="'到达港口'"
              :textAlign="'right'"
              :labelWidth="114"
              :ctnColor="'#333333'"
              :showRight="false"
            >{{items.teamEndPlace || '暂无信息'}}</listItem>
            <rline></rline>
            <listItem
              :label="'到达时间'"
              :textAlign="'right'"
              :labelWidth="114"
              :ctnColor="'#333333'"
              :showRight="false"
            >{{items.endDate || '暂无信息'}}</listItem>
          </div>
        </div>
        <div class="empty-page" v-if="carList.length === 0">
          <img src="../../assets/travelAgency/ic_wuxingxi.png" alt="" class="ic-img" />
          <p class="texts">暂无数据</p>
        </div>
      </div>
      <div class="line-box" v-if="currentIndex == 5">
        <div class="scroll-box" v-if="lineTripList.length > 1">
          <div
            :class="lists.isChoose ? 'lists-active lists' : 'lists' "
            v-for="(lists,index) in lineTripList"
            :key="index"
            @click="onLineDateChange(index)"
          >
            <p class="txt-title">行程日期</p>
            <p class="dates">{{lists.date}}</p>
          </div>
        </div>
        <div class="content-box" v-if="lineTripList.length > 0">
          <div class="onlyonelist" v-if="lineTripList.length == 1">行程日期：{{lineTripList[0].date}}</div>
          <div class="items-box" v-for="(lists,index) in lineList" :key="index">
            <div class="left-text">第{{toChinesNum(index + 1)}}站</div>
            <div class="desc-box">
              <div class="address-box">
                <div class="titles">前往城市：{{lists.gotoCityName}}</div>
                <div class="times">活动时间：{{lists.activityTime}}分钟</div>
                <div class="line-absolute">
                  <img src="../../assets/travelAgency/ic_site.png" alt class="img-city" />
                  <span class="line"></span>
                </div>
              </div>
              <div class="linedesc-box">
                <div class="line-absolute">
                  <span class="circle"></span>
                  <span class="line"></span>
                </div>
                <div class="titles">行程描述</div>
                <p class="desc">{{`${lists.activityTimeStart}至${lists.activityTimeEnd}, 游览${lists.gotoCityName}${lists.gotoCountiesName}${lists.scenicTypeStr ? lists.scenicTypeStr : ''}${lists.scenicName ? lists.scenicName : ''}, 耗时${lists.activityTime}分钟`}}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="empty-page" v-else>
          <img src="../../assets/travelAgency/ic_wuxingxi.png" alt="" class="ic-img" />
          <p class="texts">暂无数据</p>
        </div>
      </div>
      <!-- 游客信息 -->
      <div class="passenger-box" v-if="currentIndex == 6">
        <div class="items-box" v-for="(items,index) in passengerList" :key="index">
          <div class="info-box">
            <div class="usernames">{{items.name}}</div>
            <img src="../../assets/travelAgency/ic_bm_cy1.png" alt class="headimg" />
          </div>
          <div class="form-box">
            <listItem
              :label="'性别'"
              :textAlign="'right'"
              :labelWidth="114"
              :ctnColor="'#333333'"
              :showRight="false"
            >{{items.sexCode|filt()}}</listItem>
            <rline></rline>
            <!-- <listItem
              :label="'民族'"
              :showRight="false"
              :textAlign="'right'"
              :labelWidth="114"
              :ctnColor="'#333333'"
            >{{items.passengerNation || '暂无信息'}}</listItem>
            <rline></rline> -->
            <listItem
              :label="'证件类型'"
              :textAlign="'right'"
              :labelWidth="114"
              :ctnColor="'#333333'"
              :showRight="false"
            >{{items.certiCodeName || '暂无信息'}}</listItem>
            <rline></rline>
            <listItem
              :label="'证件号码'"
              :textAlign="'right'"
              :labelWidth="114"
              :ctnColor="'#333333'"
              :showRight="false"
            >{{items.certiNo || '暂无信息'}}</listItem>
            <rline></rline>
            <listItem
              :label="'联系电话'"
              :textAlign="'right'"
              :labelWidth="114"
              :ctnColor="'#333333'"
              :showRight="false"
            >{{items.phone ? items.phone : '暂无信息'}}</listItem>
            <rline></rline>
            <listItem
              :label="'客源地'"
              :textAlign="'right'"
              :labelWidth="114"
              :ctnColor="'#333333'"
              :showRight="false"
            >{{items.originTrip || '暂无信息'}}</listItem>
            <rline></rline>
            <listItem
              :label="'个人健康'"
              :textAlign="'right'"
              :labelWidth="114"
              :ctnColor="'#333333'"
              :showRight="false"
            >{{items.personHealth || '暂无信息'}}</listItem>
            <rline></rline>
            <listItem
              :label="'游客类型'"
              :textAlign="'right'"
              :labelWidth="114"
              :ctnColor="'#333333'"
              :showRight="false"
            >{{items. ageTypeStr || '暂无信息'}}</listItem>
          </div>
        </div>
        <div class="empty-page" v-if="passengerList.length === 0">
          <img src="../../assets/travelAgency/ic_wuxingxi.png" alt="" class="ic-img" />
          <p class="texts">暂无数据</p>
        </div>
      </div>
      <div class="tour-box" v-if="currentIndex == 1">
        <div v-if="travelList.length">
          <div class="form-box" v-for="(travel, index1) in travelList" :key="index1">
            <listItem
              :label="'组团社名称'"
              :textAlign="'right'"
              :labelWidth="114"
              :ctnColor="'#333333'"
              :showRight="false"
            >{{ travel.name || '暂无信息' }}</listItem>
            <rline></rline>
            <listItem
              :label="'统一社会信用代码'"
              :textAlign="'right'"
              :labelWidth="124"
              :ctnColor="'#333333'"
              :showRight="false"
            >{{ travel.businessLicence || '暂无信息' }}</listItem>
            <rline></rline>
            <listItem
              :label="'经营许可证编号'"
              :textAlign="'right'"
              :labelWidth="114"
              :ctnColor="'#333333'"
              :showRight="false"
            >{{ travel.businessLicenseNumber || '暂无信息' }}</listItem>
            <rline></rline>
            <listItem
              :label="'组团社联系人'"
              :textAlign="'right'"
              :labelWidth="100"
              :ctnColor="'#333333'"
              :showRight="false"
            >{{ travel.corporateRepresentative || '暂无信息' }}</listItem>
            <rline></rline>
            <listItem
              :label="'组团社联系电话'"
              :textAlign="'right'"
              :labelWidth="100"
              :ctnColor="'#333333'"
              :showRight="false"
            >{{ travel.crPhone || '暂无信息' }}</listItem>
          </div>
        </div>
        <div class="empty-page" v-else>
          <img src="../../assets/travelAgency/ic_wuxingxi.png" alt="" class="ic-img" />
          <p class="texts">暂无数据</p>
        </div>
      </div>
      <div class="tour-box" v-if="currentIndex == 2">
        <div v-if="travelListType.length">
          <div class="form-box" v-for="(travels, index) in travelListType" :key="index">
            <listItem
              :label="'委托社名称'"
              :textAlign="'right'"
              :labelWidth="114"
              :ctnColor="'#333333'"
              :showRight="false"
            >{{ travels.name || '暂无信息' }}</listItem>
            <rline></rline>
            <listItem
              :label="'统一社会信用代码'"
              :textAlign="'right'"
              :labelWidth="124"
              :ctnColor="'#333333'"
              :showRight="false"
            >{{ travels.businessLicence || '暂无信息' }}</listItem>
            <rline></rline>
            <listItem
              :label="'经营许可证编号'"
              :textAlign="'right'"
              :labelWidth="114"
              :ctnColor="'#333333'"
              :showRight="false"
            >{{ travels.businessLicenseNumber || '暂无信息' }}</listItem>
            <rline></rline>
            <listItem
              :label="'委托社联系人'"
              :textAlign="'right'"
              :labelWidth="100"
              :ctnColor="'#333333'"
              :showRight="false"
            >{{ travels.corporateRepresentative || '暂无信息' }}</listItem>
            <rline></rline>
            <listItem
              :label="'委托社联系电话'"
              :textAlign="'right'"
              :labelWidth="100"
              :ctnColor="'#333333'"
              :showRight="false"
            >{{ travels.crPhone || '暂无信息' }}</listItem>
          </div>
        </div>
        <div class="empty-page" v-else>
          <img src="../../assets/travelAgency/ic_wuxingxi.png" alt="" class="ic-img" />
          <p class="texts">暂无数据</p>
        </div>
      </div>
    </div>
    <div class="empty-con" v-else>
      <img src="../../assets/travelAgency/ic_empty.png" alt class="empty-icon" />
      <p class="txts">暂时没有符合您筛选条件的结果</p>
      <p class="txts">换筛选条件试试～</p>
    </div>
  </div>
</template>
<script>
    // import tab from 'comps/tab';
    import tabsScorll from './components/tabsScooll';
    import listItem from './components/list-itemone';
    import rline from './components/line';
    import api from '../../service/modules/travel';

    export default {
        components: {
            // tab,
            tabsScorll,
            rline,
            listItem
        },

        data () {
            return {
                isEmpty: true,
                currentIndex: 0,
                rankingTab: ['基本信息', '组团社信息', '委托社信息', '导游', '车辆', '行程', '游客信息'],
                carList: [],
                tripDetail: {},
                lineTripList: [],
                lineList: [],
                guideList: [],
                passengerList: [],
                travelList: [], /** 组团社 */
                travelListType: [], /** 委托社 */
                carType: [
                    {
                        key: '1',
                        value: '飞机'
                    },
                    {
                        key: '2',
                        value: '火车'
                    },
                    {
                        key: '3',
                        value: '客车'
                    },
                    {
                        key: '4',
                        value: '轮船'
                    }
                ]
            };
        },

        computed: {},

        watch: {},

        methods: {
            toChinesNum (num) {
                let changeNum = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九']; // changeNum[0] = "零"
                let unit = ['', '十', '百', '千', '万'];
                num = parseInt(num);
                let getWan = (temp) => {
                    let strArr = temp.toString().split('').reverse();
                    let newNum = '';
                    for (var i = 0; i < strArr.length; i++) {
                        newNum = (i == 0 && strArr[i] == 0 ? '' : (i > 0 && strArr[i] == 0 && strArr[i - 1] == 0 ? '' : changeNum[strArr[i]] + (strArr[i] == 0 ? unit[0] : unit[i]))) + newNum;
                    }
                    return newNum;
                }
                let overWan = Math.floor(num / 10000);
                let noWan = num % 10000;
                if (noWan.toString().length < 4) noWan = '0' + noWan;
                return overWan ? getWan(overWan) + '万' + getWan(noWan) : getWan(num);
            },
            myPending (item) {
                console.log(item, 'index');
                this.currentIndex = item.index;
                // this.currentIndex = index;
            },
            onLineDateChange (idx) {
                this.lineTripList.map((items, index) => {
                    if (idx === index) {
                        items.isChoose = true;
                        this.lineList = items.lineList
                    } else {
                        items.isChoose = false;
                    }
                });
            },
            // 基本信息
            gettraveltripDetail () {
                api.traveltripDetail({ id: this.tripId }).then(res => {
                    if (res.ret === 0) {
                        this.tripDetail = res.data.itineraryInfo
                    }
                })
            },
            // 车辆
            getTripCarList () {
                api.tripCarList({ itineraryInfoId: this.tripId, limit: 10000 }).then(res => {
                    if (res.ret === 0) {
                        this.carList = res.data.list
                    }
                })
            },
            // 行程
            getTripList () {
                api.getTripList({ itineraryInfoId: this.tripId, limit: 10000 }).then(res => {
                    if (res.ret === 0) {
                        let lineList = res.data.list
                        let dateArr = []
                        let dateArrs = []
                        // 数据格式处理
                        lineList.map((items, index) => {
                            dateArr.push(items.executeDate)
                        })
                        dateArrs = Array.from(new Set([...dateArr]))
                        let lineTripList = []
                        for (let i = 0; i < dateArrs.length; i++) {
                            let obj = {}
                            obj.date = dateArrs[i]
                            obj.isChoose = (i === 0)
                            let lineData = []
                            lineList.map((items, index) => {
                                if (items.executeDate === dateArrs[i]) {
                                    lineData.push(items)
                                }
                            })
                            obj.lineList = lineData
                            lineTripList.push(obj)
                        }
                        this.lineTripList = lineTripList
                        this.lineList = lineTripList[0].lineList
                    }
                })
            },
            // 游客
            getTripPassengerList () {
                api.getTripPassengerList({ itineraryId: this.tripId, limit: 10000 }).then(res => {
                    if (res.ret === 0) {
                        this.passengerList = res.data.list
                    }
                })
            },
            // 导游
            getTripGuideList () {
                api.getTripGuideList({ itineraryInfoId: this.tripId, limit: 10000 }).then(res => {
                    if (res.ret === 0) {
                        this.guideList = res.data.list
                    }
                })
            },
            // 组团社信息 -- 委托设信息
            getItineraryTravelList () {
                api.itineraryTravelList({ itineraryId: this.tripId }).then(res => {
                    if (res.ret === 0) {
                        let arr1 = [];
                        let arr2 = [];
                        for (let i = 0; i < res.data.list.length; i++) {
                            if (res.data.list[i].type === 0) { // 组团社
                                arr1.push(res.data.list[i]);
                            } else { // 委托社
                                arr2.push(res.data.list[i]);
                            }
                        }
                        console.log(arr1, arr2, '111111111')
                        this.travelList = arr1;
                        this.travelListType = arr2;
                    }
                })
            },
            timeChange (val1, val2) {
                let time1 = new Date(val1).getTime();
                let time2 = new Date(val2).getTime();
                let f = parseInt((time2 - time1) / 1000 / 60);
                return `${f} 分钟`;
            }
        },

        mounted () {
            this.tripId = this.$route.query.tripId
            this.gettraveltripDetail()
            this.getTripCarList()
            this.getTripList()
            this.getTripPassengerList()
            this.getTripGuideList()
            this.getItineraryTravelList()
        },
        created () {

        },
        filters: {
            filt (value) {
                if (value == 0) {
                    return '男'
                } else {
                    return '女'
                }
            }
        }
    };
</script>
<style scoped lang="less">
.tripDetail {
  width: 100%;
  min-height: 100%;
  background: rgba(251, 251, 251, 1);

  .empty-con {
    width: 100%;
    background: #fff;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 163px;
    position: absolute;
    top: 44px;
    bottom: 0;

    .empty-icon {
      width: 150px;
      height: 150px;
      margin-bottom: 32px;
    }
    .txts {
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(155, 155, 155, 1);
      line-height: 12px;
      margin-bottom: 8px;
    }
  }
  .wrapper-box {
    box-sizing: border-box;
    padding: 0 12px;
    overflow: hidden;
    padding-top: 60px;

    .ranking-tab-wrap {
      position: fixed;
      top: 0;
      right: 0;
      left: 0;
      z-index: 999999;
      background: rgba(251, 251, 251, 1);
      box-sizing: border-box;
      padding-left: 12px;
      .nav {
        // width: 120%;
      }
      .data-card-tab {
        margin-bottom: 20px;
      }
    }

    .basicinfo-box {
      .info-box {
        background: rgba(255, 255, 255, 1);
        box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.04);
        border-radius: 3px;
        margin-bottom: 12px;

        .title {
          font-size: 20px;
          font-family: PingFang SC,Arial,sans-serif;
          -webkit-font-smoothing: antialiased;
          font-weight: 700;
          color: rgba(51, 51, 51, 1);
          line-height: 28px;
          box-sizing: border-box;
          padding: 16px 16px 12px 16px;
        }
        .numbers {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(102, 102, 102, 1);
          line-height: 14px;
          box-sizing: border-box;
          padding: 0 16px 16px 16px;
        }
        .date-box {
          display: flex;
          align-items: center;
          justify-content: space-between;
          box-sizing: border-box;
          padding: 16px;

          .start-box,
          .endtime {
            .txt-title {
              font-size: 14px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: rgba(155, 155, 155, 1);
              line-height: 14px;
            }
            .txt-date {
              font-size: 16px;
              font-family: PingFang SC,Arial,sans-serif;
              -webkit-font-smoothing: antialiased;
              font-weight: 500;
              color: rgba(42, 42, 42, 1);
              line-height: 16px;
              margin: 14px 0;
            }
            .hourtime {
              height: 14px;
              display: flex;
              align-items: center;

              .hour-icon {
                width: 11px;
                // height: 11px;
                margin-right: 5px;
              }
              .times {
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: rgba(74, 74, 74, 1);
                line-height: 14px;
              }
            }
          }
          .endtime {
            text-align: right;

            .hourtime {
              justify-content: flex-end;
            }
          }
          .allday {
            height: 22px;
            border-radius: 1px;
            border: 1px solid rgba(238, 238, 238, 1);
            font-size: 12px;
            font-family: PingFangSC-Light, PingFang SC;
            font-weight: 300;
            color: rgba(74, 74, 74, 1);
            line-height: 22px;
            box-sizing: border-box;
            padding: 0 11px;
          }
        }
      }
      .msg-box {
        background: rgba(255, 255, 255, 1);
        box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.04);
        border-radius: 3px;
        margin-bottom: 12px;
      }
      .notice-box {
        margin-bottom: 24px;

        .title {
          font-size: 16px;
          font-family: PingFang SC,Arial,sans-serif;
          -webkit-font-smoothing: antialiased;
          font-weight: 500;
          color: rgba(51, 51, 51, 1);
          line-height: 40px;
        }
        .content-box {
          background: rgba(255, 255, 255, 1);
          box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.04);
          border-radius: 3px;
          box-sizing: border-box;
          padding: 16px 10px 16px 16px;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(51, 51, 51, 1);
          line-height: 20px;
        }
      }
      .phoneglobal,
      .phoneyunnan {
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(155, 155, 155, 1);
        line-height: 14px;
        text-align: center;
        margin-bottom: 10px;

        span {
          color: #36b374 !important;
        }
      }
      .phoneyunnan{
        margin-bottom: 18px;
      }
    }

    .tour-box {
      .form-box {
        background: rgba(255, 255, 255, 1);
        box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.04);
        border-radius: 3px;
        margin-bottom: 12px;

        .info-box {
          box-sizing: border-box;
          padding: 16px;
          display: flex;
          align-items: center;
          justify-content: space-between;

          .usernames {
            font-size: 20px;
            font-family: PingFang SC,Arial,sans-serif;
            -webkit-font-smoothing: antialiased;
            font-weight: 700;
            color: rgba(51, 51, 51, 1);
            line-height: 20px;
          }
          .headimg {
            width: 36px;
            height: 36px;
          }
        }
      }
    }
    .car-box {
      box-sizing: border-box;
      // padding-top: 6px;

      .form-box {
        background: rgba(255, 255, 255, 1);
        box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.04);
        border-radius: 3px;
        margin-bottom: 20px;
      }
    }

    .line-box {
      .scroll-box {
        height: 40px;
        overflow-x: scroll;
        overflow-y: hidden;
        white-space: nowrap;
        margin-bottom: 16px;

        .lists {
          display: inline-block;
          width: 81px;
          height: 40px;
          border-radius: 1px;
          background: rgba(245, 245, 245, 1);
          box-sizing: border-box;
          padding: 8px 0;
          text-align: center;
          margin-right: 16px;

          .txt-title {
            font-size: 10px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(119, 119, 119, 1);
            line-height: 10px;
            margin-bottom: 4px;
          }
          .dates {
            font-size: 10px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(119, 119, 119, 1);
            line-height: 10px;
          }
        }
        .lists-active {
          display: inline-block;
          border: 1px solid rgba(54, 179, 116, 1);
          background: #fff;
          .txt-title,
          .dates {
            color: rgba(54, 179, 116, 1);
          }
        }
      }
      .content-box {
        background: rgba(255, 255, 255, 1);
        box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.04);
        border-radius: 3px;
        box-sizing: border-box;
        // padding-bottom: 16px;
        padding-top: 16px;

        .onlyonelist {
          font-size: 14px;
          font-family: PingFang SC,Arial,sans-serif;
          -webkit-font-smoothing: antialiased;
          font-weight: 500;
          color: rgba(51, 51, 51, 1);
          line-height: 16px;
          box-sizing: border-box;
          padding-bottom: 16px;
          padding-left: 16px;
        }
        .items-box {
          display: flex;
          align-items: flex-start;
          box-sizing: border-box;
          padding: 0 16px 0 16px;
          .left-text {
            // width: 42px;
            font-size: 14px;
            font-family: PingFang SC,Arial,sans-serif;
            -webkit-font-smoothing: antialiased;
            font-weight: 500;
            color: rgba(51, 51, 51, 1);
            line-height: 14px;
            margin-right: 7px;
          }
          .desc-box {
            flex: 1;
            .address-box {
              position: relative;
              box-sizing: border-box;
              padding-left: 22px;
              padding-bottom: 16px;

              .line-absolute {
                position: absolute;
                top: 0;
                bottom: 0;
                left: 0;
                width: 17px;

                .img-city {
                  width: 17px;
                  height: 17px;
                  position: absolute;
                  top: 0;
                  left: 0;
                  right: 0;
                  z-index: 12;
                }

                .line {
                  width: 1px;
                  background: #eaeaea;
                  position: absolute;
                  top: 0;
                  bottom: 0;
                  left: 0;
                  right: 0;
                  margin: 0 auto;
                }
              }
              .titles {
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: rgba(51, 51, 51, 1);
                line-height: 14px;
                margin-bottom: 8px;
              }
              .times {
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: rgba(51, 51, 51, 1);
                line-height: 14px;
              }
            }
            .linedesc-box {
              position: relative;
              box-sizing: border-box;
              padding-left: 22px;
              // padding-bottom: 25px;

              .line-absolute {
                position: absolute;
                top: 0;
                bottom: 0;
                left: 0;
                width: 17px;

                .circle {
                  width: 12px;
                  height: 12px;
                  background: rgba(255, 255, 255, 1);
                  border: 1px solid rgba(234, 234, 234, 1);
                  border-radius: 50%;
                  position: absolute;
                  top: 0;
                  left: 0;
                  right: 0;
                  margin: 0 auto;
                  z-index: 12;
                }

                .line {
                  width: 1px;
                  background: #eaeaea;
                  position: absolute;
                  top: 0;
                  bottom: 0;
                  left: 0;
                  right: 0;
                  margin: 0 auto;
                }
              }

              .titles {
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: rgba(153, 153, 153, 1);
                line-height: 16px;
                margin-bottom: 8px;
              }
              .desc {
                font-size: 13px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: rgba(102, 102, 102, 1);
                line-height: 22px;
                margin-bottom: 16px;
              }
            }
          }
        }
      }
    }
    .passenger-box {
      .items-box {
        margin-bottom: 20px;
        .info-box {
          box-sizing: border-box;
          padding: 16px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          height: 68px;
          background: rgba(255, 255, 255, 1);
          box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.04);
          border-radius: 3px;
          margin-bottom: 16px;

          .usernames {
            font-size: 20px;
            font-family: PingFang SC,Arial,sans-serif;
            -webkit-font-smoothing: antialiased;
            font-weight: 700;
            color: rgba(51, 51, 51, 1);
            line-height: 20px;
            display: table-cell;
            vertical-align: middle;
            text-align: center;
          }

          .headimg {
            width: 36px;
            height: 36px;
          }
        }
        .form-box {
          background: rgba(255, 255, 255, 1);
          box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.04);
          border-radius: 3px;
        }
      }
    }
  }
  .scroll-box::-webkit-scrollbar{
    display: none;
  }

  .empty-page{
    box-sizing: border-box;
    padding-top: 180px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    .ic-img{
      width: 74px;
      height: 62px;
      margin-bottom: 24px;
    }

    .texts{
      font-size:14px;
      font-family:PingFangSC-Regular,PingFang SC;
      font-weight:400;
      color:rgba(153,153,153,1);
      line-height:14px;
    }
  }
}

</style>
